export default __webpack_public_path__ + "static/media/pexels-daniel-frank-305566.5020489a.jpg";